import React from 'react'
import styles from './LegalPageContainer.module.css'
import { SlimContainer } from 'modules/marketplace/layout/components/ResponsiveContainers'

type LegalPageContainerProps = {
  children?: React.ReactNode
}

const LegalPageContainer = ({ children }: LegalPageContainerProps) => (
  <SlimContainer className={styles.legalPage}>{children}</SlimContainer>
)

export default LegalPageContainer
